import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import moment from "moment";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';

const root = {}
export default root
root.name = 'processWorkPermitSJ';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	permitType: Number,
	workerSelect: Array,
	applicantSelect: Array,
	departmentSelect: Array
}
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitSJData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: '',
			//计划开始时间
			planStartTime: '',
			//计划结束时间
			planEndTime: '',
			//区域id
			locationId: 0,

			departmentId:0,
			//作业地点
			place: '',
			protectionProduct: '',
			//完工验收人
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 验收人id
			//完收验工意见
			acceptanceOpinion: '',
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			jobExecutorEmpId: 0,//TODO 作业人id
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			contractorId: null, // 申请单位id
			// TODO 新增
			certificateTypeId: 7, // 类型
		},

		//操作的缓存数据
		operaDataCache: {
			//所属单位
			unit: '',
			//受限空间名称
			csn: '',
			//内容
			content: '',
			//受限空间介质
			csmn: '',
			//危险辨识
			hi: '',
			//采样分析对象
			restrictedAnalysis: [{}, {}, {}, {}, {}, {}, {}],
			//安全措施
			sms: [],
			guardianId: 0,//监护人
			tszy: '',//涉及的其他特殊作业
			tszyzno: '',//涉及的其他特殊作业安全作业证编号
			aqjdrId: 0,//安全交底人
			jsjdrId: 0,//接受交底人
			companyCharger: 0,//作业单位负责人
			companyChargerComment: '',//作业单位负责人意见
			approveCharger: 0,//审批负责人
			approveChargerComment: '',//审批负责人意见
		},
	}
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		for (var i = 0; i < this.workPermitSJData.preWorkInfo.length; i++) {
			let element = this.workPermitSJData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}
		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitSJData.preWorkInfo = []
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitSJData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitSJData.preWorkInfo)
		this.workPermitSJData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitSJData.isShowProcessWorkPermitSelectPopup = true
	},
	returnCacheData: function () {
		return { ...this.workPermitSJData.headerDataCache, restrictedPropsDto: this.workPermitSJData.operaDataCache };
	},
	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitSJData.headerDataCache = { ...this.workPermitSJData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitSJData.operaDataCache = { ...this.workPermitSJData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitSJData.operaDataCache.restrictedAnalysis) || !this.workPermitSJData.operaDataCache.restrictedAnalysis.length) {
			this.workPermitSJData.operaDataCache.restrictedAnalysis = [{}, {}, {}, {}, {}, {}, {}];
		}
		if (!Array.isArray(this.workPermitSJData.operaDataCache.sms) || !this.workPermitSJData.operaDataCache.sms.length) {
			this.workPermitSJData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitSJData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitSJData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},
	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},
	//获取作业证中的sms
	getPermitTypeData: function () {
		const self = this;
		self.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 4 }, true).then(res => {
			self.workPermitSJData.operaDataCache.sms = res.body.data;
		});
	},
}

root.mounted = function () {
	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
	} else {
		this.workPermitSJData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}

FactoryComponents.initComponent(root);
